import React, { useState } from 'react';
import FindStoreModal from './FindStoreModal';
import * as styles from './FindInStore.module.scss';
import { useStore } from '../../../../../../contexts/StoreContext';
import useAvailability from './hooks/useAvailability';
import { getStatus, getStatusConfig } from './utils';
import { useStoreContext } from './FindInStoreContext';
import useWasParms from '../../../../../Hooks/useWasParms';

function StoreStatus() {
  const availability = useAvailability();
  const [modalOpen, setModalOpen] = useState(false);
  const { selectedStore } = useStore();
  const { selectedSku } = useStoreContext();
  const wasParms = useWasParms();

  const status = getStatus(availability, wasParms);

  const hasStore = !!selectedStore;
  const hasSku = !!selectedSku;
  const statusObj = hasStore && hasSku ? getStatusConfig(status, styles) : null;

  return (
    <div className={styles.container + ' my-3'}>
      <div className={styles.header + ' mb-3'}>
        <h2 className={styles.title}>Find In Store</h2>
        <button
          className={styles.setStore + ' p-0'}
          role='button'
          type='button'
          onClick={(e) => {
            e.preventDefault();
            setModalOpen(true);
          }}
          suppressHydrationWarning
        >
          {hasStore ? 'Change Store' : 'Set Your Store'}
        </button>
      </div>
      <div className={styles.statusRow}>
        {hasStore && hasSku ? (
          <p className={`${styles.storeName} mb-0`}>
            <span className={`${styles.icon} ${styles.stock} ${statusObj.className} mr-1`}>
              <span className='mr-1'>{statusObj.icon}</span>
              {statusObj.text}
            </span>
            at Dillard&apos;s {selectedStore.description}
          </p>
        ) : (
          <p className='mb-0'>
            {hasStore ? (
              <>
                Select an item to see availability <strong>at Dillard&apos;s {selectedStore.description}</strong>
              </>
            ) : (
              'Select a store to check for availability.'
            )}
          </p>
        )}
      </div>
      <div className={`${styles.note} mt-2`}>
        <em>In-store availability is subject to change and cannot be guaranteed. Prices may vary by store location.</em>
      </div>
      <FindStoreModal isOpen={modalOpen} onRequestClose={() => setModalOpen(false)} />
    </div>
  );
}

export default StoreStatus;
